/**
 * @Author: Nenad Brcic
 * @Date: 25.09.16
 * @Email: neno@neno.ch
 */

import React, { PropTypes } from 'react';
import styles from './list-entry-image.scss';
import CSSModules from 'react-css-modules';

const ListEntryImage = ({ imageUrl }) => (
    <div styleName="thumb" style={{backgroundImage: `url(${ imageUrl || '' })`}}>
        { !!imageUrl && <img styleName="img" src={ imageUrl } /> }
    </div>
);

ListEntryImage.propTypes = {
    imageUrl: PropTypes.string,
};

export default CSSModules(ListEntryImage, styles);


// WEBPACK FOOTER //
// ./app/components/shared/ListEntryImage/index.jsx